const $ = require('jquery');
global.$ = global.jQuery = $;

require('slick-carousel');
require('slick-carousel/slick/slick.css');
//require('slick-carousel/slick/slick-theme.css');

//require('/jeia/lib/slick/slick.min.js');
//require('/jeia/lib/slick/slick.css');
require('/jeia/lib/luminous/Luminous.min.js');
require('/jeia/lib/drift/Drift.min.js');

require('bootstrap');
